module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADVSURBVFhH7ZdhDoMgDIXLdjE4mexkcDPWx8Q4BRXXoEv4ktKHJVBb/kAhhJUxGFjKavilPa21CE7wPHjvo2ZvJTXvbY0xcK8YAPNshmFgx+KTbURKY2/MnXPpOwZ68ORSsgkgs4SU1lqP6pt7VqAlxQSUUlnbIsWPrgfFBNC/nG2R4kfXA9EKnEG0Ame47yVsRb8D/9eCWtujugW1tkevQK9Ar0AxgVZUt0Ca6hZI0ytw+SVUy7/C47T0ivkFfpQSvwuj5zOnXq4SANxr+VqPzA8nInoDupc0ICQUq2wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/TEXTFILE_32.png
// module id = 107
// module chunks = 0